import { FormGroup } from '@angular/forms';

export class PasswordValidator {

    public static passwordPattern = /([A-Za-z]{1,}).*(\d{1,}).*|(\d{1,}).*([A-Za-z]{1,}).*/;
    static validate(registrationFormGroup: FormGroup) {
        let password = registrationFormGroup.controls.password.value;
        let repeatPassword = registrationFormGroup.controls.repeatPassword.value;
        let result = {};

      if (password != null) {
        if (password && password.length > 0) {
          if (!password.match(this.passwordPattern) || password.length < 8) {
            result["passwordPatternRequired"] = true;
          }
        }
      }
        
      if (repeatPassword != null) {

        if (repeatPassword.length > 0 && repeatPassword !== password) {
          result["doesMatchPassword"] = true;
        }

        if (Object.keys(result).length > 0)
          return result;
      }

        return null;

    }
}
